export const baseurl = {
  dw1: 'dw1.myglance.org',
  dw2: 'dw2.myglance.org',
  dw3: 'dw3.myglance.org',
  dw4: 'dw4.myglance.org',
  qa: 'qa.myglance.org',
  staging: 'www.myglance.net',
  beta: 'beta.glance.net',
  production: 'www.glance.net',
};
